import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {IconsModule} from '@aztrix/icons';

import {PropertySelectComponent} from './property-select.component';
import {HelperPipesModule} from '@aztrix/helpers';

@NgModule({
  declarations: [PropertySelectComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    IconsModule,
    HelperPipesModule,
  ],
  exports: [PropertySelectComponent],
})
export class PropertySelectModule {}
